import * as Types from '../../../graphql';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetEshopOrdersCountQueryVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  filter?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetEshopOrdersCountQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getEshopOrdersCountUsingGET?: { __typename?: 'accounts_EshopOrderCountRepresentation', count?: number | null } | null } | null };

export type GetEshopOrdersQueryVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  filter?: Types.InputMaybe<Types.Scalars['String']>;
  order?: Types.InputMaybe<Types.Scalars['String']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  count?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetEshopOrdersQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getEshopOrdersUsingGET?: { __typename?: 'accounts_EshopOrderListRepresentation', recordsCount?: number | null, first?: number | null, last?: number | null, pageSize?: number | null, data?: Array<{ __typename?: 'accounts_EshopOrderRepresentation', externalId?: string | null, isPayed?: boolean | null, orderDetails?: string | null, estimatedDeliveryDate?: number | null, number?: number | null, price?: number | null, remainingAmount?: number | null, submittedDate?: number | null, createdByUserName?: string | null, createdDate?: string | null, eshopProductEid?: string | null, clientEid?: string | null, invoiceEid?: string | null, stornoInvoiceEid?: string | null, statusCode?: string | null, eshopProduct?: { __typename?: 'accounts_EshopProductRepresentation', externalId?: string | null, code?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, instruction?: string | null, price?: number | null, deliveryDays?: number | null, acquireSource?: string | null, requiresDocuments?: boolean | null, isVisible?: boolean | null, tags?: string | null, requiresInput?: boolean | null, eshopProductCategoryEid?: string | null, eshopProductCategory?: { __typename?: 'accounts_EshopProductCategoryRepresentation', externalId?: string | null, name?: string | null } | null } | null, client?: { __typename?: 'accounts_ClientRepresentation', companyName?: string | null, companyCode?: string | null, externalId?: string | null, registrationNumber?: string | null, fiscalNumber?: string | null } | null, status?: { __typename?: 'accounts_SysEshopStatusesRepresentation', code?: string | null, name?: string | null, nameEn?: string | null } | null, eshopOrderAttachments?: Array<{ __typename?: 'accounts_EshopOrderAttachmentRepresentation', fileEid?: string | null, fileName?: string | null, fileSize?: number | null, displayOrder?: number | null }> | null }> | null, totals?: { __typename?: 'accounts_EshopOrderTotalsRepresentation', currency?: string | null, totalPrice?: number | null, totalRemainingAmount?: number | null } | null } | null } | null };

export type GetEshopOrderQueryVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  orderEid?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetEshopOrderQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getEshopOrderUsingGET?: { __typename?: 'accounts_EshopOrderRepresentation', externalId?: string | null, isPayed?: boolean | null, orderDetails?: string | null, estimatedDeliveryDate?: number | null, number?: number | null, price?: number | null, remainingAmount?: number | null, submittedDate?: number | null, createdByUserName?: string | null, createdDate?: string | null, eshopProductEid?: string | null, clientEid?: string | null, invoiceEid?: string | null, stornoInvoiceEid?: string | null, statusCode?: string | null, eshopProduct?: { __typename?: 'accounts_EshopProductRepresentation', externalId?: string | null, code?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, instruction?: string | null, price?: number | null, deliveryDays?: number | null, acquireSource?: string | null, requiresDocuments?: boolean | null, isVisible?: boolean | null, tags?: string | null, requiresInput?: boolean | null, eshopProductCategoryEid?: string | null, eshopProductCategory?: { __typename?: 'accounts_EshopProductCategoryRepresentation', externalId?: string | null, name?: string | null } | null } | null, client?: { __typename?: 'accounts_ClientRepresentation', companyName?: string | null, companyCode?: string | null, externalId?: string | null, registrationNumber?: string | null, fiscalNumber?: string | null } | null, status?: { __typename?: 'accounts_SysEshopStatusesRepresentation', code?: string | null, name?: string | null, nameEn?: string | null } | null, eshopOrderAttachments?: Array<{ __typename?: 'accounts_EshopOrderAttachmentRepresentation', fileEid?: string | null, fileName?: string | null, fileSize?: number | null, displayOrder?: number | null }> | null } | null } | null };

export type GetEshopProductsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.Scalars['String']>;
  order?: Types.InputMaybe<Types.Scalars['String']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  count?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetEshopProductsQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getEshopProductsUsingGET?: { __typename?: 'accounts_EshopProductListRepresentation', recordsCount?: number | null, first?: number | null, last?: number | null, pageSize?: number | null, data?: Array<{ __typename?: 'accounts_EshopProductRepresentation', externalId?: string | null, code?: string | null, name?: string | null, description?: string | null, shortDescription?: string | null, instruction?: string | null, price?: number | null, deliveryDays?: number | null, acquireSource?: string | null, requiresDocuments?: boolean | null, isVisible?: boolean | null, tags?: string | null, requiresInput?: boolean | null, eshopProductCategoryEid?: string | null, eshopProductCategory?: { __typename?: 'accounts_EshopProductCategoryRepresentation', externalId?: string | null, name?: string | null } | null }> | null } | null } | null };

export type GetEshopProductQueryVariables = Types.Exact<{
  productEid?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetEshopProductQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getEshopProductUsingGET?: { __typename?: 'accounts_EshopProductRepresentation', externalId?: string | null, code?: string | null, name?: string | null, shortDescription?: string | null, description?: string | null, instruction?: string | null, price?: number | null, deliveryDays?: number | null, acquireSource?: string | null, requiresDocuments?: boolean | null, isVisible?: boolean | null, tags?: string | null, requiresInput?: boolean | null, eshopProductCategoryEid?: string | null, eshopProductCategory?: { __typename?: 'accounts_EshopProductCategoryRepresentation', externalId?: string | null, name?: string | null } | null } | null } | null };

export type UpsertEshopOrderMutationVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  data?: Types.InputMaybe<Types.Accounts_EshopOrderRepresentationInput>;
}>;


export type UpsertEshopOrderMutation = { __typename?: 'Mutation', accounts?: { __typename?: 'accounts_mutation', upsertEshopOrderUsingPUT?: { __typename?: 'accounts_Eid', externalId?: string | null } | null } | null };

export type CancelEshopOrderMutationVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  data?: Types.InputMaybe<Types.Accounts_EshopOrderOpDataRepresentationInput>;
}>;


export type CancelEshopOrderMutation = { __typename?: 'Mutation', accounts?: { __typename?: 'accounts_mutation', cancelEshopOrderUsingPOST?: { __typename?: 'accounts_SuccessResponse', Message?: string | null } | null } | null };

export type GetEshopOrderCommentQueryVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  orderEid?: Types.InputMaybe<Types.Scalars['String']>;
  showIsInternal?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type GetEshopOrderCommentQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', getEshopOrderCommentUsingGET?: { __typename?: 'accounts_EshopOrderCommentListRepresentation', comments?: Array<{ __typename?: 'accounts_EshopOrderCommentsRepresentation', externalId?: string | null, comment?: string | null, isInternal?: boolean | null, isFromKeez?: boolean | null, createdByUserName?: string | null, createdDate?: string | null, attachments?: Array<{ __typename?: 'accounts_EshopOrderAttachmentRepresentation', fileEid?: string | null, fileName?: string | null, fileSize?: number | null, displayOrder?: number | null }> | null }> | null } | null } | null };

export type PostEshopOrderMessageMutationVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  orderEid?: Types.InputMaybe<Types.Scalars['String']>;
  body?: Types.InputMaybe<Types.Accounts_EshopOrderMessageRepresentationInput>;
}>;


export type PostEshopOrderMessageMutation = { __typename?: 'Mutation', accounts?: { __typename?: 'accounts_mutation', postEshopOrderMessageUsingPOST?: { __typename?: 'accounts_Eid', externalId?: string | null } | null } | null };

export type DeleteEshopOrderCommentMutationVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  orderEid?: Types.InputMaybe<Types.Scalars['String']>;
  orderCommentEid?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type DeleteEshopOrderCommentMutation = { __typename?: 'Mutation', accounts?: { __typename?: 'accounts_mutation', deleteEshopOrderCommentUsingDELETE?: { __typename?: 'accounts_SuccessResponse', Message?: string | null } | null } | null };

export const GetEshopOrdersCountDocument = gql`
    query getEshopOrdersCount($clientEid: String, $filter: String) {
  accounts {
    getEshopOrdersCountUsingGET(clientEid: $clientEid, filter: $filter) {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEshopOrdersCountGQL extends Apollo.Query<GetEshopOrdersCountQuery, GetEshopOrdersCountQueryVariables> {
    document = GetEshopOrdersCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEshopOrdersDocument = gql`
    query getEshopOrders($clientEid: String, $filter: String, $order: String, $offset: Int, $count: Int) {
  accounts {
    getEshopOrdersUsingGET(clientEid: $clientEid, filter: $filter, order: $order, offset: $offset, count: $count) {
      recordsCount
      first
      last
      pageSize
      data {
        externalId
        isPayed
        orderDetails
        estimatedDeliveryDate
        number
        price
        remainingAmount
        submittedDate
        createdByUserName
        createdDate
        eshopProductEid
        eshopProduct {
          externalId
          code
          name
          description
          shortDescription
          instruction
          price
          deliveryDays
          acquireSource
          requiresDocuments
          isVisible
          tags
          requiresInput
          eshopProductCategoryEid
          eshopProductCategory {
            externalId
            name
          }
        }
        clientEid
        client {
          companyName
          companyCode
          externalId
          registrationNumber
          fiscalNumber
        }
        invoiceEid
        stornoInvoiceEid
        statusCode
        status {
          code
          name
          nameEn
        }
        eshopOrderAttachments {
          fileEid
          fileName
          fileSize
          displayOrder
        }
      }
      totals {
        currency
        totalPrice
        totalRemainingAmount
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEshopOrdersGQL extends Apollo.Query<GetEshopOrdersQuery, GetEshopOrdersQueryVariables> {
    document = GetEshopOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEshopOrderDocument = gql`
    query getEshopOrder($clientEid: String, $orderEid: String) {
  accounts {
    getEshopOrderUsingGET(clientEid: $clientEid, orderEid: $orderEid) {
      externalId
      isPayed
      orderDetails
      estimatedDeliveryDate
      number
      price
      remainingAmount
      submittedDate
      createdByUserName
      createdDate
      eshopProductEid
      eshopProduct {
        externalId
        code
        name
        description
        shortDescription
        instruction
        price
        deliveryDays
        acquireSource
        requiresDocuments
        isVisible
        tags
        requiresInput
        eshopProductCategoryEid
        eshopProductCategory {
          externalId
          name
        }
      }
      clientEid
      client {
        companyName
        companyCode
        externalId
        registrationNumber
        fiscalNumber
      }
      invoiceEid
      stornoInvoiceEid
      statusCode
      status {
        code
        name
        nameEn
      }
      eshopOrderAttachments {
        fileEid
        fileName
        fileSize
        displayOrder
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEshopOrderGQL extends Apollo.Query<GetEshopOrderQuery, GetEshopOrderQueryVariables> {
    document = GetEshopOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEshopProductsDocument = gql`
    query getEshopProducts($filter: String, $order: String, $offset: Int, $count: Int) {
  accounts {
    getEshopProductsUsingGET(filter: $filter, order: $order, offset: $offset, count: $count) {
      recordsCount
      first
      last
      pageSize
      data {
        externalId
        code
        name
        description
        shortDescription
        instruction
        price
        deliveryDays
        acquireSource
        requiresDocuments
        isVisible
        tags
        requiresInput
        eshopProductCategoryEid
        eshopProductCategory {
          externalId
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEshopProductsGQL extends Apollo.Query<GetEshopProductsQuery, GetEshopProductsQueryVariables> {
    document = GetEshopProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEshopProductDocument = gql`
    query getEshopProduct($productEid: String) {
  accounts {
    getEshopProductUsingGET(productEid: $productEid) {
      externalId
      code
      name
      shortDescription
      description
      instruction
      price
      deliveryDays
      acquireSource
      requiresDocuments
      isVisible
      tags
      requiresInput
      eshopProductCategoryEid
      eshopProductCategory {
        externalId
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEshopProductGQL extends Apollo.Query<GetEshopProductQuery, GetEshopProductQueryVariables> {
    document = GetEshopProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertEshopOrderDocument = gql`
    mutation upsertEshopOrder($clientEid: String, $data: accounts_EshopOrderRepresentationInput) {
  accounts {
    upsertEshopOrderUsingPUT(clientEid: $clientEid, data: $data) {
      externalId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertEshopOrderGQL extends Apollo.Mutation<UpsertEshopOrderMutation, UpsertEshopOrderMutationVariables> {
    document = UpsertEshopOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelEshopOrderDocument = gql`
    mutation cancelEshopOrder($clientEid: String, $data: accounts_EshopOrderOpDataRepresentationInput) {
  accounts {
    cancelEshopOrderUsingPOST(clientEid: $clientEid, data: $data) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelEshopOrderGQL extends Apollo.Mutation<CancelEshopOrderMutation, CancelEshopOrderMutationVariables> {
    document = CancelEshopOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEshopOrderCommentDocument = gql`
    query getEshopOrderComment($clientEid: String, $orderEid: String, $showIsInternal: Boolean) {
  accounts {
    getEshopOrderCommentUsingGET(clientEid: $clientEid, orderEid: $orderEid, showIsInternal: $showIsInternal) {
      comments {
        externalId
        comment
        isInternal
        isFromKeez
        createdByUserName
        createdDate
        attachments {
          fileEid
          fileName
          fileSize
          displayOrder
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEshopOrderCommentGQL extends Apollo.Query<GetEshopOrderCommentQuery, GetEshopOrderCommentQueryVariables> {
    document = GetEshopOrderCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PostEshopOrderMessageDocument = gql`
    mutation postEshopOrderMessage($clientEid: String, $orderEid: String, $body: accounts_EshopOrderMessageRepresentationInput) {
  accounts {
    postEshopOrderMessageUsingPOST(clientEid: $clientEid, orderEid: $orderEid, body: $body) {
      externalId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PostEshopOrderMessageGQL extends Apollo.Mutation<PostEshopOrderMessageMutation, PostEshopOrderMessageMutationVariables> {
    document = PostEshopOrderMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEshopOrderCommentDocument = gql`
    mutation deleteEshopOrderComment($clientEid: String, $orderEid: String, $orderCommentEid: String) {
  accounts {
    deleteEshopOrderCommentUsingDELETE(clientEid: $clientEid, orderEid: $orderEid, orderCommentEid: $orderCommentEid) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEshopOrderCommentGQL extends Apollo.Mutation<DeleteEshopOrderCommentMutation, DeleteEshopOrderCommentMutationVariables> {
    document = DeleteEshopOrderCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }